/* eslint-disable max-len */
import { api } from '../services/api';
import { FETCH_PROYECTO_PATH } from '../services/path';
import {
  FETCH_PROYECTO, FETCH_PROYECTO_BY_ID, FETCH_PROYECTO_BY_ID_GRAFICA, LIMPIAR_ESTADO_PROYECTO
} from './types';

export const fetchProyecto = (perPage, offSet) => (dispatch) => dispatch({
  type: FETCH_PROYECTO,
  promise: api.get(`${FETCH_PROYECTO_PATH}?perPage=${perPage}&offSet=${offSet}`)
});

export const fetchProyectoById = (id) => (dispatch) => dispatch({
  type: FETCH_PROYECTO_BY_ID,
  promise: api.get(`${FETCH_PROYECTO_PATH}/${id}`)
});
export const fetchProyectoByIdGrafica = (id) => (dispatch) => dispatch({
  type: FETCH_PROYECTO_BY_ID_GRAFICA,
  promise: api.get(`${FETCH_PROYECTO_PATH}/${id}`)
});

export const limpiarProyecto = () => (dispatch) => dispatch({
  type: LIMPIAR_ESTADO_PROYECTO,
});
